import request from '@/utils/pay_request'
// 支付接口
export function getPageOption(params) {
  return request({
    url: 'pay/money/getPageOption',
    method: 'POST',
    params
  })
}
// 创建订单
export function createOrder(params) {
  return request({
    url: 'pay/order/createOrder',
    method: 'POST',
    params
  })
}
// 获取地址列表
export function addressList(params) {
  return request({
    url: 'pay/address/addressList',
    method: 'POST',
    params
  })
}
// 设置默认地址
export function updateAddress(params) {
  return request({
    url: 'pay/address/updateAddress',
    method: 'POST',
    params
  })
}
// 获取地区数据
export function getDistrict(params) {
  return request({
    url: 'pay/address/getDistrict',
    method: 'POST',
    params
  })
}
// 新建、编辑地址
export function editAddress(params) {
  return request({
    url: 'pay/address/editAddress',
    method: 'POST',
    params
  })
}
// 支付是否成功
export function isSuccess(params) {
  return request({
    url: 'pay/order/isSuccess',
    method: 'POST',
    params
  })
}

//请求消费协议
export function getAgreement(params){
  return request({
      url: 'pay/order/getPayProtocol',
      method: 'post',
      params
  })
}
// 金卡  校验|激活Vip
export function getVipByGoldCard(params) {
  return request({
    url: 'pay/order/openvip',
    method: 'get',
    params
  })
}
// 设置订单成功状态
export function setSuccessForWx(params) {
  return request({
    url: 'pay/order/setSuccessForWx',
    method: 'post',
    params
  })
}